import type React from "react";
import { SpinLogo, Title } from "./components";
import "./styles.css";

export const BaseContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="container">
      <SpinLogo />
      <Title />
      {children}
    </div>
  );
};
